module.exports = __webpack_public_path__ + "img/l.d950a820.webp";